import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { PushServiceService } from './services/push-service.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private pushService: PushServiceService,
  ) {
    this.initializeApp()
  }

  async initializeApp() {
    this.pushService.initPush();
  }
}
